import { cleanObject } from '@shared/utils';
import { get } from '@/redux/requests/api.js';
import normalizeRequestFailure from '@/redux/requests/lib/normalizeRequestFailure.js';
import toValidationFailure from '@/redux/requests/lib/toValidationFailure.js';

const listThreadEventsPage = ({ threadId, limit = undefined, beforeSeq = undefined, afterSeq = undefined, authToken = undefined, signal = undefined, action = undefined, loader = undefined, onResponse = undefined } = {}, callback) => {
  const normalizedThreadId = String(threadId || '').trim();

  if (!normalizedThreadId) {
    return toValidationFailure('threadId is required');
  }

  return get(`/v1/pieve/threads/${encodeURIComponent(normalizedThreadId)}/events`, {
    authToken,
    signal,
    action,
    loader,
    callback,
    query: cleanObject(
      {
        limit: limit ?? undefined,
        beforeSeq: beforeSeq ?? undefined,
        afterSeq: afterSeq ?? undefined
      },
      { strict: true }
    ),
    onResponse: (responseShape) => {
      const normalizedResponseShape = normalizeRequestFailure({
        responseShape,
        fallbackMessage: 'Failed to load task events'
      });

      if (typeof onResponse === 'function') {
        return onResponse(normalizedResponseShape) || normalizedResponseShape;
      }

      return normalizedResponseShape;
    }
  });
};

export default listThreadEventsPage;
